import * as React from "react";
import { DatePicker } from "../DatePicker";
import { TextInput } from "../TextInput";
import { useWatch } from "react-hook-form";
import { Address } from "./Address";
import { stateOptions } from "data";

export function BussinessOwnerInfo({ register, control }) {
  const mirroredCarrier = useWatch({ control, name: "step2.carrier" });
  const [openDob, setOpenDob] = React.useState(false);

  const today = new Date();
  const cutoff = new Date();
  cutoff.setFullYear(today.getFullYear() - 18);
  return (
    <div className="rounded-lg border p-4 space-y-4">
      <h3 className="text-lg font-semibold">Business Owner Info</h3>
      <h2 className="text-md font-semibold !mt-0">
        (PLEASE USE THE PHYSICAL ADDRESS LISTED ON THE INSURED'S SAFER)
      </h2>

      <div className="grid gap-4 md:grid-cols-2">
        <TextInput
          register={register}
          label="First Name"
          id="owner-first"
          stepName="step2.owner.firstName"
          stepId="step2"
        />
        <TextInput
          register={register}
          label="Last Name"
          id="owner-last"
          stepName="step2.owner.lastName"
          stepId="step2"
        />
      </div>

      <div className="space-y-2">
        <Address
          register={register}
          control={control}
          states={stateOptions}
          title="Address"
          formKey={"step2.owner.address"}
          stepId={"step2"}
          version="v2"
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <DatePicker
            control={control}
            open={openDob}
            setOpen={setOpenDob}
            label="DOB"
            className="mt-1"
            disabled={(date) => {
              return date > today || date > cutoff;
            }}
            name="step2.owner.dob"
            step="step2"
            endMonth={new Date(cutoff.getFullYear(), cutoff.getMonth() + 1)}
          />
        </div>
        {mirroredCarrier?.includes("Progressive") && (
          <TextInput
            register={register}
            label="Business Type"
            id="business-type"
            stepName="step2.owner.businessType"
            stepId="step2"
            extraInfo={"Example: Trucker, Landscaper, Janitorial, Hotshot"}
          />
        )}
      </div>

    </div>
  );
}
